import React, { FunctionComponent, useContext } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'rootReducer';
import { RecordingModel } from 'features/recordings/RecordingModel';
import { allPublicRecordingsSelector } from 'features/recordings/recordingsSelectors';
import { EmptyRecordings } from 'features/channel/components/ChannelRecordings/EmptyRecordings';
import { PaginatedRecordings } from 'features/channel/components/ChannelRecordings/PaginatedRecordings';
import { UserAgentContext } from 'features/user-agent/userAgent';
import { InfiniteScrollRecordings } from './InifinteScrollRecordings';

export const ChannelRecordings: FunctionComponent = () => {
  const channel = useSelector(
    (state: RootState) => state.channel.channelDetails
  );
  const channelisLoaded = useSelector(
    (state: RootState) => state.channel.isLoaded
  );

  const allRecordings: RecordingModel[] = useSelector(
    allPublicRecordingsSelector
  );

  const { isListenerAppWebview } = useContext(UserAgentContext);

  const loading = useSelector((state: RootState) => state.recordings.isLoading);

  if (!channelisLoaded || channel == null) {
    return null;
  }

  if (allRecordings.length === 0 && !loading) {
    return <EmptyRecordings username={channel.username} />;
  }

  if (isListenerAppWebview) {
    return (
      <InfiniteScrollRecordings recordings={allRecordings} itemsPerPage={20} />
    );
  }

  return <PaginatedRecordings recordings={allRecordings} itemsPerPage={20} />;
};
